"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    switchBase: {
      '&$checked': {
        color: '#009FDD'
      },
      '&$checked + $track': {
        backgroundColor: '#009FDD'
      }
    },
    checked: {},
    track: {}
  };
};

exports.default = _default;